import React from 'react'
import { Typography, Row, Col } from 'antd'
import {
    SearchOutlined,
    CalendarOutlined,
    TrophyOutlined,
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import './HowItWorks.css'

const { Title } = Typography

const HowItWorks: React.FC = () => {
    const { t } = useTranslation()

    return (
        <div className="howitworks-container" id="how-it-works">
            <Title className="title" level={2}>
                {t('home.howItWorks.title')}
            </Title>

            {/* Steps Container */}
            <div className="steps-box">
                <Row gutter={[32, 32]} justify="center">
                    <Col xs={24} sm={24} md={8}>
                        <div className="step">
                            <div className="step-title">
                                <SearchOutlined className="icon" />
                                <Title className="title" level={4}>
                                    {t('home.howItWorks.browseSessions')}
                                </Title>
                            </div>
                            <div>
                                <img
                                    src="/img/howitworks-01.png"
                                    alt={t('common.alt.step01')}
                                />
                            </div>
                        </div>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                        <div className="step">
                            <div className="step-title">
                                <CalendarOutlined className="icon" />
                                <Title className="title" level={4}>
                                    {t('home.howItWorks.bookYourSpot')}
                                </Title>
                            </div>
                            <div>
                                <img
                                    src="/img/howitworks-02.png"
                                    alt={t('common.alt.step02')}
                                />
                            </div>
                        </div>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                        <div className="step">
                            <div className="step-title">
                                <TrophyOutlined className="icon" />
                                <Title className="title" level={4}>
                                    {t('home.howItWorks.comeByPlay')}
                                </Title>
                            </div>
                            <div>
                                <img
                                    src="/img/howitworks-03.png"
                                    alt={t('common.alt.step03')}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default HowItWorks
